module.exports = __webpack_public_path__ + "static/cta-moc-2-1-1be1c8299bfe5ed0b1a18d7475cf9bfb.png";